/* eslint-disable react-hooks/exhaustive-deps */
import './style.css';
import React from 'react';
import Footer from '../../Components/Footer';
import flash2 from '../../images/venteFlash.jpeg'
import CountdownNeumorphism from '../../Components/Countdown';
import { Button } from '@mui/material';
import ScrollToTop from '../../Components/scrollup'
import { ThemeProvider } from '@mui/material/styles';
import { createTheme } from '@mui/material/styles';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import slugify from '../../Utils/slugify';
export default function VenteFlashPage() {
  const theme = createTheme({
    palette: {
      primary: {
         
              main: '#ffeb3b',
              dark: '#ffcd38',
              contrastText: '#000',
      },
    },
  });
  return (
    <ThemeProvider theme={theme}>
    <div className='products100' >
       <img
            src={flash2}
            alt='flash'
            className='flashImgHome'
          /> 
        <div className='venteflashCounter'>  
     {/* <h3>coming soon </h3>*/}
  <CountdownNeumorphism
  targetDate="2026-06-01T23:59:59"
/>
      </div>
      
        <ScrollToTop/>       
     <div className='flashContain'>
      
          {itemData.map((item) => (
           <div className="images-zoom-container-flash">
  <a href={item.link}>
    <img
      src={require(`../../images/flash/${item.img}.jpeg`)}
      alt={item.img}
      className="flashImg"
    />
  </a>
 
  <div className="flashButtonWrapper">
    <a href={item.link}>
   <Button
  variant="contained"
  endIcon={<KeyboardArrowRightIcon />}
  sx={{
    px: { xs: 1.5, sm: 3 },
    py: { xs: 0.4, sm: 0.7 },
    fontSize: { xs: "10px", sm: "12px", md: "13px" },
    fontWeight: 700,
    borderRadius: "30px",
    fontFamily:'Exo',
    textTransform: "none",
    background: "linear-gradient(45deg, #ffeb3b, #ff9800)",
    color: "#000",
    boxShadow: "0 4px 15px rgba(255, 152, 0, 0.4)",
    transition: "all 0.3s ease",
    "&:hover": {
      background: "linear-gradient(45deg, #ff9800, #ff6f00)",
      boxShadow: "0 6px 20px rgba(255, 111, 0, 0.6)",
      transform: "scale(1.05)",
    },
  }}
>
  Profiter
</Button>
</a>
  </div>
   
</div>
          
          ))}
   
          
        </div>
    
      <Footer/>
    </div>
    </ThemeProvider>
  );
}
// eslint-disable-next-line no-unused-vars
const itemData = [
  {
    img: "flash1",
    link: `/bons-plans/12`,
  },

  {
    img: "flash2",
    link: `/bons-plans/13`,
  },

  {
    img: "flash3",
    link: `/produit/${slugify("informatique & lifestyle")}/${slugify("lifestyle")}/${slugify("accessoires")}/${slugify("femme")}/${slugify("montre femme MK5799")}`,
  },

  {
    img: "flash4",
    link: `/produit/${slugify("électroménager & cuisine")}/${slugify("maison")}/${slugify("DECA FER A REPASSER 2400W KEEN001W")}`,
  },

  {
    img: "flash5",
    link: `/produit/${slugify("électroménager & cuisine")}/${slugify("cuisine")}/${slugify("cafe et petit dejeuner")}/${slugify("DECA BOUILLOIRE 1.5L 2200W KEKT004w")}`,
  },

  {
    img: "flash6",
    link: `/produit/${slugify("électroménager & cuisine")}/${slugify("cuisine")}/${slugify("preparation culinaire")}/${slugify("MIXEUR SKY 1200W NOIR")}`,
  },

  {
    img: "flash7",
    link: `/produit/${slugify("informatique & lifestyle")}/${slugify("lifestyle")}/${slugify("accessoires")}/${slugify("femme")}/${slugify("montre femme MK5896")}`,
  },

  {
    img: "flash8",
    link: `/produit/${slugify("informatique & lifestyle")}/${slugify("lifestyle")}/${slugify("accessoires")}/${slugify("femme")}/${slugify("montre femme MK5896")}`,
  },
];